import { PERMANENT_COOKIE_NAME } from '@packages/domain/constants/cookies';
import { type UseQueryOptions, useQuery } from '@tanstack/react-query';
import { useSelector } from 'react-redux';
import { getStudentID } from 'selectors/ui/ui';
import { cookies } from 'utils/cookies/cookies';
import {
  type ExperimentFlagResponse,
  experiments,
} from '../../services/payex/experiments/experiments';

type CheckFlagParams = {
  flagName: string;
  userContext?: Record<string, string | boolean | number>;
  userId?: string;
  userEmail?: string;
};

type CheckFlagResponse = ExperimentFlagResponse;

export const useExperimentFlag = (
  params: CheckFlagParams,
  opts: UseQueryOptions<CheckFlagResponse, unknown, boolean> = {},
) => {
  const studentId = useSelector(getStudentID) as string;
  const fingerprint = cookies.read(PERMANENT_COOKIE_NAME);
  const resolvedUserId = params.userId || fingerprint || studentId || undefined;

  const { data, ...rest } = useQuery<CheckFlagResponse, unknown, boolean>({
    queryKey: [
      'experiment-flag',
      params.flagName,
      params.userContext,
      resolvedUserId,
      params.userEmail,
    ],
    queryFn: () =>
      experiments.checkFlag(
        params.flagName,
        params.userContext,
        resolvedUserId,
        params.userEmail,
      ),
    select: data => !!data?.enabled,
    ...opts,
  });

  return { value: data ?? false, ...rest };
};
